import { formatPhoneNumberIntl } from 'react-phone-number-input';

// Display helper: "+917709295909" -> "+91 77092-95909" (a space after the country
// code, hyphens between the national digit groups). Returns the original string
// unchanged when it can't be parsed (so non-E.164 legacy values aren't blanked).
export function formatPhone(value) {
  if (!value) return '';
  const intl = formatPhoneNumberIntl(value); // "+91 77092 95909" or "" if unparseable
  if (!intl) return value;
  const parts = intl.split(' ');
  if (parts.length < 2) return intl;
  return `${parts[0]} ${parts.slice(1).join('-')}`;
}
